module.exports = __webpack_public_path__ + "img/CW11WJW-HQ.e2edcaff.png";